import { ChangeDetectorRef, Component, Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { BillingManagementService } from 'src/service/billing-management.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LocalService, ReceiptType, Status } from 'src/service/local.service';
import { ReplaceFonts, ReplaceFontType } from 'src/app/supporting/replaceFont';

@Component({
  selector: 'app-receipt-view',
  templateUrl: './receipt-view.component.html',
  styleUrl: './receipt-view.component.scss'
})
export class ReceiptViewComponent {
  @Input() receiptId: string = ''; @Input() ctryCode: string = ''; @Input() printingLanguageId: string = ''; @Input() printContent: string = '';
  marginLeft: number = 0; contentWidth: string = '0%'; maxBodyHeight = 0; isNoAccess = false; @Input() isPreview = false;

  isRequeCheckInitiated = false; isOldPrintEnable = false; printingTemplateId: string;
  isPrint: boolean = false; @Output() onPrinted = new EventEmitter();
  @Output() onClose = new EventEmitter();

  elementIds: any; htmlId: string = '';
  browserPrintingRenderingTime: number = 100;
  browserPrintingPreviewTime: number = 100;
  browserPrintingCloseTime: number = 100;

  constructor(public localService: LocalService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private billingManagementService: BillingManagementService, private cdr: ChangeDetectorRef) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      receipt_content: 'receipt_content_' + this.htmlId,
      receipt_iframe: 'receipt_iframe_' + this.htmlId,
      receipt_iframe_print: 'receipt_iframe_print_' + this.htmlId,
      receipt_iframe_wrapper: 'receipt_iframe_wrapper_' + this.htmlId
    };

  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight() + 30;
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    if (!this.isPreview) {
      this.route.params.subscribe(routeParams => {
        this.printingTemplateId = routeParams.templateId;
        this.receiptId = routeParams.receiptId;
        this.ctryCode = routeParams.ctryCode;
        if (!this.localService.reques) {
          this.onLoad();
        } else {
          this.onLoad();
        }
      });

      if (window.location.href.indexOf('rv-print') > -1) {
        this.isPrint = true;
      }
    } else {
      this.onSetToIframe();
    }
  }

  OnClosePopup() {
    this.isPreview = false;
    this.isPrint = false;
    this.printContent = '';
    this.onClose.emit();
  }

  onCheckReques() {
    if (!this.isRequeCheckInitiated) {
      this.isRequeCheckInitiated = true;
      if (!this.localService.reques) {
        this.configurationManagementService.getReques().subscribe(result => {
          if (result && result.status == Status.Success) {
            this.localService.reques = this.localService.decryptCrypto(result.value, environment.ui);
            this.onLoad();
          }
        });
      } else {
        this.onLoad();
      }
    } else {
      this.onLoad();
    }
  }

  onReset() {
    this.isNoAccess = false;
    this.printContent = '';
  }

  onLoad() {
    this.printingLanguageId = this.localService.selected.applicationLanguage;
    this.billingManagementService.getReceiptHtml(this.receiptId, this.printingLanguageId, this.printingTemplateId).subscribe(result => {
      if (result.status == Status.Success) {
        this.printContent = result.value;
        this.onSetToIframe();
      } else if (result.status == Status.NotAllowed) {
        this.isNoAccess = true;
      }
    });
  }

  onPrint() {
    this.isOldPrintEnable = false;
    this.isPrint = false;
    const iframe: any = document.getElementById(this.elementIds.receipt_iframe);

    if (iframe) {
      // Wait for iframe to render and fonts to load
      setTimeout(async () => {
        try {
          if (iframe.contentWindow) {
            // Use FontFaceSet API to wait for font load
            await iframe.contentDocument?.fonts.load("1em EnglishFont");
            await iframe.contentDocument?.fonts.ready;

            iframe.contentWindow.onafterprint = () => {
              setTimeout(() => {
                this.isPrint = false;
                this.onPrinted.emit();
              }, this.browserPrintingCloseTime);
            };

            // Print after font is ready
            iframe.contentWindow?.print();
          }
        } catch (error) {
          console.error("Font loading failed:", error);
          iframe.contentWindow?.print(); // fallback
        }
      }, this.browserPrintingPreviewTime); // slight delay to let rendering start
    }
  }

  onSetToIframe() {
    if (this.printContent && this.printContent.length > 5) {
      this.printContent = ReplaceFonts(this.printContent, ReplaceFontType.FontName);
      setTimeout(() => {
        const iframe: any = document.getElementById(this.elementIds.receipt_iframe);

        if (iframe) {
          let doc = iframe.contentWindow || iframe.contentDocument;
          if (doc.document) doc = doc.document;

          if (doc) {
            doc.open();
            doc.write(this.printContent);
            doc.close();

            iframe.onload = function () {
              iframe.style.height = (iframe.contentWindow.document.body.scrollHeight) + 'px';

              setTimeout(() => {
                const tbl = iframe.contentWindow.document.getElementById('tbl-content');
                if (tbl) {
                  if (tbl.className.indexOf('not-a4') > -1) {
                    let classWidth: string = tbl.style.width;
                    if (classWidth.indexOf('mm')) {
                      const widthInMM = classWidth.split('mm')[0];
                      classWidth = (parseInt(widthInMM) + 1) + 'mm';
                      iframe.style.width = classWidth;
                    }
                  } else if (tbl.className.indexOf('fixed-') > -1) {
                    const classNames = tbl.className.split(' ');
                    const finalClassName = classNames.find(x => x.indexOf('fixed-') > -1);

                    if (finalClassName) {
                      let classWidth: string;

                      for (const sheet of Array.from(iframe.contentWindow.document.styleSheets)) {
                        if (!classWidth) {
                          try {
                            const rules = (sheet as CSSStyleSheet).cssRules;
                            const rule = Array.from(rules).find(x => x['selectorText'] == '.' + finalClassName);
                            if (rule) {
                              classWidth = rule['style'].width;
                            }
                          } catch (e) {
                            // Skip cross-origin stylesheets
                            continue;
                          }
                        }
                      }

                      if (classWidth) {
                        if (classWidth.indexOf('mm') > -1) {
                          const widthInMM = classWidth.split('mm')[0];
                          classWidth = (parseInt(widthInMM) + 5) + 'mm';
                        }
                        iframe.style.width = classWidth;
                      }
                    }
                  } else {
                    const width = tbl.style.width;
                    iframe.style.width = width;
                  }
                } else {
                  const fixedDirect = iframe.contentWindow.document.getElementsByClassName('fixed-direct');

                  if (fixedDirect && fixedDirect.length > 0) {
                    iframe.style.width = '100%';
                  }
                }
              }, 200);
            };
          }
        }
      }, this.browserPrintingRenderingTime);
    }
  }

  printWindow: Window;
  onPrintFinal() {
    this.printContent = ReplaceFonts(this.printContent, ReplaceFontType.FontName);
    this.isOldPrintEnable = true;
    this.isPrint = true;
    let width = 400; let height = 500;
    var left = (screen.width / 2) - (width / 2);
    var top = (screen.height / 2) - (height / 2);
    this.printWindow = window.open('', '', 'dialog=no;toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
    this.printWindow.document.write(this.printContent);
    if (this.printContent.indexOf('min_height_req_for_tbody') > -1) {
      const thead = this.printWindow.document.getElementsByTagName('thead')[0];
      const tfoot = this.printWindow.document.getElementsByTagName('tfoot')[0];
      const tbodyHeight = 1122.519 - (thead.clientHeight + tfoot.clientHeight) - 100;

      let tbodyDiv = this.printWindow.document.getElementsByClassName('min_height_req_for_tbody')[0];
      const multipleHeight = parseInt((tbodyDiv.clientHeight / tbodyHeight).toString()[0]) + 1;
      tbodyDiv.setAttribute("style", "min-height: " + (tbodyHeight * multipleHeight) + "px");
    }

    this.printWindow.focus();
    this.printWindow.document.title = this.receiptId;
    this.printWindow.addEventListener('afterprint', this.onAfterPrintType2);

    setTimeout(() => {
      this.printWindow.print();
    }, this.browserPrintingPreviewTime);
  }

  // Event callback for after print
  onAfterPrintType2 = (): void => {
    setTimeout(() => {
      this.printWindow.close();
      this.isPrint = false;
      this.onPrinted.emit();
    }, this.browserPrintingCloseTime);
  };

  onClose2() {
    if (this.printWindow) {
      this.printWindow.close();
    }
    this.isPrint = false;
    this.onPrinted.emit();
  }
}
